import MaskBreakageRouter from './MaskBreakageRouter';

export default MaskBreakageRouter;
